export default {
  navigation: {
    title: "L'Entrepôt",
    "search-bar": {
      placeholder: "Que cherchez-vous ?",
    },
    support: "Assistance",
    primary: {
      categories: "Catégories",
      manufacturers: "Marques",
      "article-groups": "Groupes d'articles",
    },
    secondary: {
      products: "Produits",
      manufacturers: "Marques",
      suppliers: "Fournisseurs",
    },
  },
  manufacturers: {
    title: "Nos marques",
    description:
      "Retrouvez les marques innovantes et de confiance du secteur photovoltaïque qui optent pour la vente en ligne pour réduire vos prix.",
  },
  suppliers: {
    title: "Nos fournisseurs",
    description:
      "Les fournisseurs se rendent disponibles pour vous proposer des solutions innovantes avec des prix uniquement disponibles en ligne.",
  },
  support: {
    title: "Parler à un humain",
    description:
      "Contactez les fournisseurs et fabricants pour plus d'assistance concernant une commande, une livraison ou un remboursement.",
  },
  filters: {
    panel: {
      type: "Type",
      "rating-stc": "Cote STC",
      "product-warranty": "Garantie du produit",
      "frame-type": "Type de cadre",
      "frame-color": "Couleur du cadre",
      "back-sheet-color": "Couleur de la feuille arrière",
      "cell-quantity": "Quantité de cellules",
      efficiency: "Facteur d'efficacité du module",
      height: "Hauteur",
      width: "Largeur",
      length: "Longueur",
    },
    battery: {
      "capacity-usable": "Capacité utilisable",
      type: "Type de Batterie",
      "efficiency-roundtrip": "Efficacité aller-retour",
    },
    inverter: {
      "rated-power": "Puissance nominale",
      "is-microinverter": "Micro-onduleur",
      "is-hd-wave": "Vague HD",
      "is-synergy": "Synergie",
      "is-integrated": "Intégré",
      "is-battery-charger": "Chargeur de batterie",
      phases: "Phases",
    },
    common: {
      height: "Hauteur",
      width: "Largeur",
      length: "Longueur",
      manufacturers: "Fabricants",
    },
  },
  about: {
    "reservable-listings": {
      title: "Achat groupé",
      description:
        "Participez à nos achats groupés pour obtenir le prix d’une expédition en conteneur avec une petite quantité !",
      button: "En savoir plus sur les achats groupés",
    },
    collections: {
      title: "Parcourir le catalogue par équipement",
      action: "Parcourir le catalogue complet",
    },
    hero: {
      title: "Le marché pour les",
      subtitle: "professionnels du solaire",
      description:
        "Trouvez des modules solaires, des onduleurs et des batteries fiables, comparez les fournisseurs, demandez des devis et recevez rapidement vos commandes.",
      "fast-delivery": "Livraison rapide",
      "several-choices-available": "Plusieurs choix disponibles",
      "regular-offers": "Offres régulières",
    },
    "purchasing-methods": {
      heading: "Comment acheter ?",
      title: "Achetez votre équipement comme vous le souhaitez",
      "you-want": "tu veux",
      description:
        "Vous en avez assez de vous procurer du matériel à l'ancienne ? Voici votre boutique du solaire tout-en-un qui vous offre la possibilité d'acheter du matériel à des petits prix pour vous faire gagner du temps.",
      checkout: {
        title: "Achat direct",
        description:
          "Vous ne voulez plus perdre de temps à enquêter auprès de marchands ? Consultez la liste de produits des fournisseurs et distributeurs disponibles à l’achat immédiat.",
      },
      rfq: {
        title: "Demande de devis",
        description:
          "Vous avez l’habitude de vous renseigner auprès de vos fournisseurs pour trouver la meilleure offre ? Demandez un devis pour vérifier si vous pouvez bénéficier d’un meilleur prix. ",
      },
      reservation: {
        title: "Achat groupé",
        description:
          "Réservez votre quantité lors des programmes d’achat de groupe afin d’obtenir des prix par conteneur favorables.",
      },
    },
    values: {
      perks: {
        "more-choice": {
          title: "Plusieurs choix disponibles",
          description:
            "Comparez plusieurs fournisseurs pour trouver le meilleur prix",
        },
        "fast-delivery": {
          title: "Livraison rapide",
          description:
            "Les fournisseurs expédieront dès qu’ils auront reçu votre commande par notre plateforme",
        },
        "regular-offers": {
          title: "Offres régulières",
          description:
            "Des offres uniques sur le matériel offert toute l’année dans la boutique comme nulle part ailleurs !",
        },
      },
    },
  },

  compare: {
    "view-item": "Voir le produit",
    title: "Comparer les produits de l’Entrepôt",
    "first-product-placeholder": "Rechercher premier modèle",
    "second-product-placeholder": "Rechercher deuxième modèle",
    description:
      "Comparer les fiches techniques et comptabilités de nos produits disponibles pour commande en ligne.",
  },
  "search-bar": {
    results: "Produits",
    "search-for": "Recherche de",
    "no-results": "Aucun résultat",
  },
  "price-unit": {
    unit: "Pièce",
    container: "Container",
    pallet: "Palette",
    box: "Box",
  },
}
